import React, {
  memo,
  type ReactElement,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { Logger } from '@saviynt/common';
import { Box, Button, Typography } from '@saviynt/design-system';
import cx from 'classnames';

import {
  AAG_SOD_DETAILS_WITH_ID,
  AAG_SOD_RECOMMENDATION_WITH_ID,
  AAG_SOD_REPORT,
  CF_NEU_BLD,
} from '../../../shared/constants';
import { useInvertedLocalize, useNavigateTo } from '../../../shared/hooks';
import { globalActions } from '../../../shared/store/actions';

import './ViolationsTime.css';

/**
 * * TODO
 * - Write a description
 */
function ViolationsTime(): ReactElement {
  const l = useInvertedLocalize();
  const dispatch = useDispatch();
  const { navigateToUrl } = useNavigateTo();

  // Demo setting global state to false after 1s
  useEffect(() => {
    setTimeout(() => {
      dispatch(globalActions.setIsGlobalLoading(false));
    }, 1000);
  }, [dispatch]);

  const timeSectionClasses = cx('Sod-ViolationsTime');

  // This is temporary until the card is finished
  const parentRef = useRef<HTMLDivElement | null>(null);
  const [topChild, setTopChild] = useState<string | null>(null);

  // Temp logger added for merge conflicts
  useEffect(() => {
    Logger.log('topChild', topChild);
  }, [topChild]);

  useEffect(() => {
    const handleScroll = () => {
      if (!parentRef.current) {
        return;
      }

      const parent = parentRef.current;
      const parentRect = parent.getBoundingClientRect();
      let closestChild: string | null = null;
      const minDifference = 5;

      // Get all child elements (including nested ones)
      const children = parent.querySelectorAll<HTMLDivElement>(
        '.RiskTile--isConnected'
      );

      children.forEach((child) => {
        const childRect = child.getBoundingClientRect();
        const difference = Math.abs(childRect.top - parentRect.top);

        // Find the child closest to the parent's top
        if (difference < minDifference) {
          closestChild = child.textContent?.trim() ?? 'Unknown Child';
        }
      });

      setTopChild(closestChild);
    };

    const parent = parentRef.current;

    if (parent) {
      parent.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    return () => {
      if (parent) {
        parent.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <Box className={timeSectionClasses}>
      <section className='Sod-ViolationsTime-main'>
        <Box className='demo-toberemoved-testing-tabs'>
          <Typography kind='h1' color={CF_NEU_BLD}>
            {l(
              'This tab content is placeholder. Please take a look at more of these pages.'
            )}
          </Typography>
          <Button
            type='button'
            kind='filled'
            size='large'
            onClick={() => {
              navigateToUrl(AAG_SOD_RECOMMENDATION_WITH_ID);
            }}>
            {l('Go To Recommendations Page')}
          </Button>
          <Button
            type='button'
            kind='filled'
            size='large'
            onClick={() => navigateToUrl(AAG_SOD_REPORT)}>
            {l('Go To Report Page')}
          </Button>
          <Button
            type='button'
            kind='filled'
            size='large'
            onClick={() => {
              navigateToUrl(AAG_SOD_DETAILS_WITH_ID);
            }}>
            {l('Go To Details Page')}
          </Button>
        </Box>
      </section>
    </Box>
  );
}

export default memo(ViolationsTime);
